import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useAuth } from 'react-oidc-context';

import { Box, Button, ButtonBase, CircularProgress, ListItem, ListItemButton, ListItemText, styled } from '@mui/material';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import { Form } from 'react-bootstrap';
import { SnackbarContext } from '../../App';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default ({ show, onHide, subId, onReload }) => {
  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, setSessionExpired } = useContext(SnackbarContext);

  const [
    subscriptionId,
    setSubscriptionId,
  ] = useState(subId);

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    buttonDisable,
    setButtonDisable,
  ] = useState(true);

  const [
    subscriptionStatus,
    setSubscriptionStatus,
  ] = useState('active');

  function cancelSubscriptionHandler() {
    setIsLoading(true);

    fetch(`${window.origin}/api/stripe/subscription/${subscriptionId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${auth.user?.access_token}`,
        // Don't set "Content-Type" if you're not sending a body
      },
      // no `body`
    }).then((response) => {
      if (response.status === 403) {
        // setSessionExpired(true)
        throw new Error('Session expired');
      }

      console.log(subscriptionId);

      setSubscriptionStatus('active');

      let intervalId = setInterval(() => {
        fetch(`${window.origin}/api/stripe/subscription/${subscriptionId}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.user?.access_token}`,
          },
        }).then((response) => {
          if (response.status === 403) {
            setSessionExpired(true);
            throw new Error('Session expired');
          }

          return response.json();
        }).then((data) => {
          console.log(data);

          let subStat = data.subscription_status;

          if (subStat != 'active') {
            setSubscriptionStatus(subStat);
            clearInterval(intervalId);
          }
        });
      }, 100);
    }).catch((error) => {
      setIsLoading(false);
      // console.error(error);
      // setSnackBarMessage('Unknown error occurred, Please try again later')
      // setSnackBarShow(true)
    });
  }

  useEffect(() => {
    setSubscriptionId(subId);
  }, [subId]);

  useEffect(() => {
    if (subscriptionStatus == 'canceled') {
      onReload();
      setIsLoading(false);
      onHide();
    }
  }, [subscriptionStatus]);

  return (

    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >
      {/* <SessionExpiredModal show={sessionExpired}/> */}

      <Modal.Body style={{ padding: '2vw 3vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.7)' }}>

        <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '600' }}>Cancel Subscription</h4>

        <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)' }}>Please confirm you want to cancel this subscription</p>

        <Button
          disabled={isLoading}
          onClick={() => { cancelSubscriptionHandler(subscriptionId); }}
          variant="outlined"
          style={{
            borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '0vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
            width: '100%', marginTop: '1vw' }}
        >
          {isLoading ? 'Cancelling ...' : 'Confirm'}
        </Button>

        <Button
          onClick={onHide}
          variant="outlined"
          style={{
            borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 15, 30, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundColor: 'rgb(254, 254, 255, 0.4)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
            width: '100%', marginTop: '1vw' }}
        >
          Not Now
        </Button>

      </Modal.Body>
    </Modal>
  );
};


